import { render, staticRenderFns } from "./classExam.vue?vue&type=template&id=214df7dd&scoped=true"
import script from "./classExam.vue?vue&type=script&lang=js"
export * from "./classExam.vue?vue&type=script&lang=js"
import style0 from "./classExam.vue?vue&type=style&index=0&id=214df7dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214df7dd",
  null
  
)

export default component.exports